import React, { useRef, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslations } from 'next-intl';

import StyledQuoteSlider from './quote-slider.style';
import Headline from '../../atoms/headline/headline';
import Quote from '../../molecules/quote/quote';
import Container from '../../layout/container/container';
import { ArrowLeft, ArrowRight } from '../../icons/arrow/arrow';

type QuoteSliderProps = {
  headline?: string;
  quotes: {
    image?: {
      url: string;
    };
    copy?: string;
    source?: string;
    wide?: boolean;
    color?: string;
  }[];
};

const QuoteSlider = ({ headline, quotes }: QuoteSliderProps) => {
  const t = useTranslations();
  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  return (
    <StyledQuoteSlider>
      {headline && (
        <Container>
          <Headline tag="h2" secondary className="quoteSlider__headline">
            {headline}
          </Headline>
        </Container>
      )}
      <div className="quoteSlider__outer">
        <Container>
          <Swiper
            ref={sliderRef}
            spaceBetween={30}
            slidesPerView="auto"
            loop
            freeMode
            breakpoints={{
              768: {
                spaceBetween: 50
              }
            }}
          >
            {[...quotes, ...quotes]?.map((quote, index) => (
              <SwiperSlide key={index}>
                <Quote {...quote} color="black" />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="quoteSlider__meta">
            <div className="quoteSlider__controls">
              <button
                type="button"
                aria-label={t('slider.prevSlide')}
                onClick={() => handlePrev()}
                className="quoteSlider__button quoteSlider__prevButton"
              >
                <ArrowLeft role="img" ariaLabel={t('slider.prevSlide')} />
              </button>
              <button
                type="button"
                aria-label={t('slider.nextSlide')}
                onClick={() => handleNext()}
                className="quoteSlider__button quoteSlider__nextButton"
              >
                <ArrowRight role="img" ariaLabel={t('slider.nextSlide')} />
              </button>
            </div>
          </div>
        </Container>
      </div>
    </StyledQuoteSlider>
  );
};

export default QuoteSlider;
